type AchievementCardProps = {
  title: string;
  detail?: string;
};

export function AchievementCard({ title, detail }: AchievementCardProps) {
  return (
    <li className="border-l-2 border-ember bg-black/40 px-5 py-4">
      <div className="font-display text-sm tracking-wide text-foreground">{title}</div>
      {detail ? <div className="mt-1 text-sm text-foreground/65">{detail}</div> : null}
    </li>
  );
}
